exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fix-notifications-for-pwa {\n  margin-left: -2px;\n  margin-right: 16px;\n}\n.fix-notifications-for-pwa.show.pwa .dropdown-menu {\n    top: 80px !important;\n}\n.notifications-dropdown button {\n  padding: 0;\n}\n.badge-header {\n  position: absolute !important;\n  margin-top: -2px;\n  font-size: 77.5%;\n}\n.badge-variant {\n  color: #ea4e2c;\n  letter-spacing: 0.03rem;\n  background-color: #fcede9;\n}\n", ""]);

// exports
